export const trayLabels = [
  "Demand",
  "Competition",
  "Trendy niche",
  "Trendy niche",
  "Search volume",
  "Top-5 Products",
  "ROI",
  "Score",
];

export const trayData = [
  {
    title: "Product 1",
    demand: "High",
    competition: "Mid",
    trendy: "Yes",
    trendyScore: 25,
    search: "55-70k",
    top: "below 50%",
    roi: "below 150%",
    score: 3.0,
  },
  {
    title: "Product 2",
    demand: "High",
    competition: "Mid",
    trendy: "Yes",
    trendyScore: 25,
    search: "55-70k",
    top: "below 50%",
    roi: "below 150%",
    score: 3.0,
  },
  {
    title: "Product 3",
    demand: "High",
    competition: "Mid",
    trendy: "Yes",
    trendyScore: 25,
    search: "55-70k",
    top: "below 50%",
    roi: "below 150%",
    score: 3.0,
  },
];
